import { GENERAL_API_URL, PACKAGE_API_URL } from 'components/ApiConstants';
import { sendGet } from 'state/actions/actions';
import ActionTypes from 'state/ActionTypes';

export function loadTags() {
  return sendGet({
    data: {},
    url: `${GENERAL_API_URL()}/tags`,
    requestType: ActionTypes.BASE_TAGS_REQUEST,
    successType: ActionTypes.BASE_TAGS_SUCCESS,
    failedType: ActionTypes.BASE_TAGS_FAILED,
  });
}

export function loadCategoryTags() {
  return sendGet({
    data: {},
    url: `${GENERAL_API_URL()}/categorytags`,
    requestType: ActionTypes.BASE_CATEGORYTAGS_REQUEST,
    successType: ActionTypes.BASE_CATEGORYTAGS_SUCCESS,
    failedType: ActionTypes.BASE_CATEGORYTAGS_FAILED,
  });
}

export function loadBranchTags() {
  return sendGet({
    data: {},
    url: `${GENERAL_API_URL()}/branchetags`,
    requestType: ActionTypes.BASE_BRANCHTAGS_REQUEST,
    successType: ActionTypes.BASE_BRANCHTAGS_SUCCESS,
    failedType: ActionTypes.BASE_BRANCHTAGS_FAILED,
  });
}

export function loadDomains() {
  return sendGet({
    data: {},
    url: `${GENERAL_API_URL()}/domains`,
    requestType: ActionTypes.BASE_DOMAINS_REQUEST,
    successType: ActionTypes.BASE_DOMAINS_SUCCESS,
    failedType: ActionTypes.BASE_DOMAINS_FAILED,
  });
}

export function loadFunctionTags() {
  return sendGet({
    data: {},
    url: `${GENERAL_API_URL()}/functiontags`,
    requestType: ActionTypes.BASE_FUNCTIONTAGS_REQUEST,
    successType: ActionTypes.BASE_FUNCTIONTAGS_SUCCESS,
    failedType: ActionTypes.BASE_FUNCTIONTAGS_FAILED,
  });
}

export function loadArcheTypes() {
  return sendGet({
    data: {},
    url: `${GENERAL_API_URL()}/archetypes`,
    requestType: ActionTypes.BASE_ARCHETYPES_REQUEST,
    successType: ActionTypes.BASE_ARCHETYPES_SUCCESS,
    failedType: ActionTypes.BASE_ARCHETYPES_FAILED,
  });
}

export function loadPackages() {
  return sendGet({
    url: PACKAGE_API_URL(),
    requestType: ActionTypes.BASE_PACKAGES_REQUEST,
    successType: ActionTypes.BASE_PACKAGES_SUCCESS,
    failedType: ActionTypes.BASE_PACKAGES_FAILED,
  });
}
